"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsEventType = void 0;
var ChannelsEventType;
(function (ChannelsEventType) {
    ChannelsEventType["WEBHOOK_ORDER"] = "WEBHOOK_ORDER";
    ChannelsEventType["ORDER_CREATE"] = "ORDER_CREATE";
    ChannelsEventType["ORDER_SYNC"] = "ORDER_SYNC";
    ChannelsEventType["ORDER_ACKNOWLEDGE"] = "ORDER_ACKNOWLEDGE";
    ChannelsEventType["PRODUCT_CREATE"] = "PRODUCT_CREATE";
    ChannelsEventType["SHIPMENT_UPDATE"] = "SHIPMENT_UPDATE";
    ChannelsEventType["INCREMENTAL_PRODUCT_CREATE"] = "INCREMENTAL_PRODUCT_CREATE";
    ChannelsEventType["CANCELLATION_UPDATE"] = "CANCELLATION_UPDATE";
    ChannelsEventType["ORDER_SYNC_RETRY"] = "ORDER_SYNC_RETRY";
    ChannelsEventType["SELLER_ORDER_CANCELLATION_REQUEST"] = "SELLER_ORDER_CANCELLATION_REQUEST";
    ChannelsEventType["B2B_ORDER_CREATE"] = "B2B_ORDER_CREATE";
})(ChannelsEventType = exports.ChannelsEventType || (exports.ChannelsEventType = {}));
//# sourceMappingURL=ChannelsEventType.js.map